module.exports = __webpack_public_path__ + "img/icon-close.dba311a5.svg";